import waterledgerLogo from "@images/waterledger-logo.png";

const WaterLedgerLogo = () => {
  return (
    <img src={waterledgerLogo} alt="Water Ledger logo" width="30" height="34" />
  );
};

export default WaterLedgerLogo;
